import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const UnderConstruction = (props) => {
    // Initialize AOS
    useEffect(() => {
        AOS.init({ duration: 800 });
    }, []);

    return (
        <>
            <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 container mx-auto shadow rounded-lg kanit-light">
                <div
                    className="bg-yellow-500 p-4 rounded-full shadow-lg mb-8"
                    data-aos="zoom-in"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-16 w-16 text-white animate-bounce"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 6h16M4 10h16M10 14h4M4 18h16"
                        />
                    </svg>
                </div>
                <h2
                    className="text-2xl sm:text-4xl font-bold "
                    data-aos="fade-up"
                >
                    {props.name}
                </h2>
                <h1
                    className="text-3xl sm:text-5xl font-bold "
                    data-aos="fade-up"
                >
                    Under Construction
                </h1>
                <p
                    className="text-gray-500 mt-4 max-w-md"
                    data-aos="fade-up"
                    data-aos-delay="200"
                >
                    This section is currently being built. Check back soon for
                    updates!
                </p>
                <div
                    className="flex space-x-2 mt-8"
                    data-aos="fade-up"
                    data-aos-delay="400"
                >
                    <div className="w-4 h-4 bg-yellow-500 rounded-full animate-pulse"></div>
                    <div className="w-4 h-4 bg-yellow-500 rounded-full animate-pulse delay-200"></div>
                    <div className="w-4 h-4 bg-yellow-500 rounded-full animate-pulse delay-400"></div>
                </div>
            </div>
        </>
    );
};

export default UnderConstruction;
